<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <h1 v-show="notfound">El enlace ya no esta disponible</h1>
                <CForm v-show="!notfound">
                  <h1>Compra en un solo enlace</h1>
                  <CForm :validated="true">
                    <CCardBody>
                      <CCardTitle
                        ><center>Datos de Facturación</center></CCardTitle
                      >
                      <CInput
                        placeholder="Identificación"
                        v-model="form.identification"
                        required
                        :valid-feedback="validator.identificationValid"
                        :invalid-feedback="validator.identificationInvalid"
                        @blur="loadPartner"
                        @keypress="onlyNumberId"
                      >
                        <template #prepend-content
                          ><font-awesome-icon
                            v-if="!loadingPartner"
                            icon="id-card" />
                          <CSpinner v-if="loadingPartner" variant="grow" size="sm"
                        /></template>
                      </CInput>
                      <CRow>
                        <CCol xs="12" md="12" v-if="!completepart">
                          <CSelect
                            aria-label="Tipo de identificación"
                            v-model="form.identityType"
                            :options="identityType"
                            @change="partnerType"
                          >
                            <template #prepend-content
                              ><font-awesome-icon icon="id-card"
                            /></template>
                          </CSelect>
                        </CCol>
                        <CCol xs="12" md="12" v-if="!completepart">
                          <CSelect
                            aria-label="Tipo de socio de negocio"
                            v-model="form.societyType"
                            :options="societyType"
                            @change="partnerType"
                          >
                            <template #prepend-content
                              ><font-awesome-icon icon="id-card"
                            /></template>
                          </CSelect>
                        </CCol>
                      </CRow>
                      <CSelect
                        aria-label="Tipo de contribuyente"
                        v-model="form.typeTaxpayer"
                        v-show="false"
                        :options="typeTaxpayer"
                        @change="partnerType"
                        v-if="!completepart"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="id-card"
                        /></template>
                      </CSelect>
                      <CInput
                        placeholder="Nombre"
                        v-model="name"
                        required
                        valid-feedback="validator.nameValid"
                        invalid-feedback="validator.nameInvalid"
                        :is-valid="validator.name"
                        v-if="(!completepart || !valid.cardname)"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="user-tie"
                        /></template>
                      </CInput>
                      <CInput
                        placeholder="Apellido"
                        v-model="lastname"
                        required
                        valid-feedback="validator.nameValid"
                        invalid-feedback="validator.nameInvalid"
                        :is-valid="validator.name"
                        v-if="this.form.societyType !== '02' & (!completepart || !valid.cardname)"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="user-tie"
                        /></template>
                      </CInput>
                      <CInput
                        type="email"
                        placeholder="Correo"
                        autocomplete="email"
                        v-model="form.email"
                        required
                        valid-feedback="validator.emailValid"
                        invalid-feedback="validator.emailInvalid"
                        :is-valid="validator.email"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="at"
                        /></template>
                      </CInput>
                      <CInput
                        placeholder="Dirección"
                        v-model="form.address"
                        required
                        valid-feedback="validator.addressValid"
                        invalid-feedback="validator.addressInvalid"
                        :is-valid="validator.adress"
                        v-if="(!completepart || !valid.street)"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="map-marker-alt"
                        /></template>
                      </CInput>
                      <CInput
                        placeholder="Ciudad"
                        v-model="form.city"
                        required
                        valid-feedback="validator.cityValid"
                        invalid-feedback="validator.cityInvalid"
                        :is-valid="validator.city"
                        v-if="(!completepart || !valid.city)"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="city"
                        /></template>
                      </CInput>
                      <CInput
                        type="phone"
                        placeholder="Teléfono"
                        autocomplete="phone"
                        v-model="form.phone"
                        valid-feedback="validator.phoneValid"
                        invalid-feedback="validator.phoneInvalid"
                        :is-valid="validator.phone"
                        @keypress="onlyNumber"
                      >
                        <template #prepend-content
                          ><font-awesome-icon icon="phone"
                        /></template>
                      </CInput>
                    </CCardBody>
                  </CForm>
                  <CRow v-if="alert.show">
                    <CAlert :color="alert.color" dismissible>
                      {{ alert.message }}
                    </CAlert>
                  </CRow>
                  <CRow v-show="!complete">
                    <CCol col="12" sm="12" lg="12">
                      <input type="checkbox" v-model="termsagreement" /> Estoy de acuerdo con las <a href="https://www.bsmart.ec/privacidad/" target="_blank">Políticas de privacidad</a>
                    </CCol>
                    <CCol col="12" class="text-right">
                      <CButton
                        class="js-payment-checkout"
                        color="info"
                        @click="payment()"
                      >
                        <font-awesome-icon icon="handshake" v-if="!loading" />
                        <CSpinner v-if="loading" variant="grow" size="sm" />
                        Continuar con el pago
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-right py-1"
              body-wrapper
            >
              <CCardBody>
                <img src="img/logo.png" class="c-avatar-img" />
                <CDataTable hover striped :items="products" :fields="fields" v-show="!notfound">
                  <template #Price="data">
                    <td>
                      {{ formatPrice(data.item.Price) }}
                    </td>
                  </template>
                </CDataTable>
                <p v-show="!notfound">
                  Subtotal
                  <span class="prices"
                    >${{ formatPrice(promotion.taxbaseamount) }}</span
                  >
                </p>
                <p v-show="!notfound">
                  Impuesto
                  <span class="prices"
                    >${{
                      formatPrice(promotion.total - promotion.taxbaseamount)
                    }}</span
                  >
                </p>
                <p v-show="!notfound">
                  Total
                  <span class="prices"
                    >${{ formatPrice(promotion.total) }}</span
                  >
                </p>
                <img src="img/boxes.png" alt="" style="width: 100%">
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from "axios";
import Resource from "@/api/resource";
const paymentResponseResource = new Resource("payment_response");
const transactionResource = new Resource("transaction");

export default {
  data: function () {
    return {
      termsagreement: false,
      name: "",
      lastname: "",
      promotion: {
        id: 0,
        paymentCode: "",
        begin_at: null,
        end_at: null,
        max_uses: 0,
        used: 0,
        tax: 0,
        taxbaseamount: 0,
        total: 0,
        created_by: 1,
        created_at: "",
        updated_at: "",
      },
      form: {
        name: "",
        identification: "",
        email: "",
        address: "",
        phone: "",
        celphone: "",
        identityType: "02",
        societyType: "01",
        typeTaxpayer: "01",
        total: 0.0,
        taxbaseamount: 0.0,
        tax: 15.0,
        city: "",
      },
      validator: {
        identification: null,
        identificationValid: "",
        identificationInvalid: "",
        name: null,
        nameValid: "",
        nameInvalid: "",
        email: null,
        emailValid: "",
        emailInvalid: "",
        address: null,
        addressValid: "",
        addressInvalid: "",
        phone: null,
        phoneValid: "",
        phoneInvalid: "",
        city: null,
        cityValid: "",
        cityInvalid: "",
      },
      products: [],
      fields: [
        { key: "ItemName", label: "Nombre" },
        { key: "qty", label: "Cantidad" },
        { key: "Price", label: "Precio" },
      ],
      loading: false,
      loadingPartner: false,
      complete: false,
      notfound: false,
      alert: {
        color: "danger",
        message: "success",
        show: false,
      },
      identityType: [
        { value: "02", label: "CEDULA" },
        { value: "01", label: "RUC" },
        { value: "03", label: "PASAPORTE" },
      ],
      societyType: [
        { value: "01", label: "Persona Natural" },
        { value: "02", label: "Sociedad" },
      ],
      typeTaxpayer: [
        {
          value: "01",
          label: "Persona Natural No obligada a llevar contabilidad",
        },
        {
          value: "02",
          label: "Persona Natural obligada a llevar contabilidad",
        },
        { value: "03", label: "Sociedad" },
        { value: "04", label: "Contribuyente Especial" },
        { value: "05", label: "Contribuyente Regimen Simplificado" },
        { value: "06", label: "Otros" },
        { value: "07", label: "Servicios Profesionales" },
      ],
      continue: false,
      completepart: false,
      validEmail: false,
      valid: {
        cardname: false,
        street: false,
        city: false,
      },
    };
  },
  async mounted() {
    await axios
      .get(process.env.VUE_APP_BACKEND_URL+"/api/promotion/" + this.$route.params.id)
      .then((response) => {
        if(response.data.paylink){
          this.promotion = response.data.paylink;
          this.products = response.data.products;
          if (!this.promotion.id) {
            this.notfound = true;
          }
        }else{
          this.notfound = true; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
    let paymentezScript = document.createElement("script");
    paymentezScript.setAttribute(
      "src",
      "https://cdn.paymentez.com/ccapi/sdk/payment_checkout_3.0.0.min.js"
    );
    paymentezScript.setAttribute("charset", "UTF-8");
    document.head.appendChild(paymentezScript);

    let paymentezStyle = document.createElement("link");
    paymentezStyle.setAttribute(
      "href",
      'https://cdn.paymentez.com/ccapi/sdk/payment_stable.min.css" rel="stylesheet'
    );
    paymentezStyle.setAttribute("rel", "stylesheet");
    paymentezStyle.setAttribute("type", "text/css");
    document.head.appendChild(paymentezStyle);

    window.addEventListener("popstate", function () {
      paymentCheckout.close();
    });
    window.complete = this;
  },
  methods: {
    partnerType() {
      if (this.form.identityType == "02") {
        this.form.societyType = "01";
      }
      if (this.form.societyType == "02") {
        this.form.typeTaxpayer = "03";
      } else {
        this.form.typeTaxpayer = "01";
      }
      this.validateCedula();
    },
    async loadPartner() {
      this.loading = true;
      this.loadingPartner = true;
      this.validateCedula();
      if(this.continue){
        await axios
          .get(process.env.VUE_APP_BACKEND_URL+"/api/partnerPublic/"+this.form.identification)
          .then((response) => {
            if(response.data.E_Mail){
              this.form.name = response.data.CardName;
              this.form.email = response.data.E_Mail;
              this.form.address = response.data.Street;
              this.form.phone = response.data.Phone1;
              this.form.celphone = response.data.Cellular;
              this.form.city = response.data.City;
              this.form.identityType = response.data.U_HBT_TIPO_ID;
              this.form.societyType = response.data.U_HBT_TIPPRO;
              this.form.typeTaxpayer = response.data.U_HBT_TIPCONT;
              this.name = response.data.CardName;
              this.lastname = "";
              this.valid.cardname = response.data.CardName;
              this.valid.street = response.data.Street;
              this.valid.city = response.data.City;
              this.continue = true;
              this.completepart = true;
              this.validator.identification = true;
              this.alert.show = true;
              this.alert.color = "success";
              this.alert.message = "Parece que ya eres clientes, valida tus datos para continuar";
            }else{
              this.valid.cardname = true;
              this.valid.street = true;
              this.valid.city = true;
              this.form.email = null;
              this.form.phone = null;
              this.continue = false;
              this.completepart = false;
              this.validateCedula();
              this.alert.show = false;
            }
          })
          .catch((error) => {
            this.form.name = "";
            this.form.email = "";
            this.form.address = "";
            this.form.phone = "";
            this.form.celphone = "";
            this.form.city = "";
            this.name = "";
            this.lastname = "";
            this.continue = false;
            this.completepart = false;
          }).finally(() => {
            this.loading = false;
            this.loadingPartner = false;
          });
      }
    },
    async payment() {
      // Generate reference
      var reference;
      await transactionResource.post('reference', {
        
        user: {
          id: "1",
          email: this.form.email,
          phone: this.form.phone,
        },
        order: {
          description: this.form.address?this.form.address:'Compra desde enlace',
          amount: this.roundToTwo(this.promotion.total),
          vat: this.roundToTwo(
            this.promotion.total - this.promotion.taxbaseamount
          ),
          //order_installments_type: 0, //0 corriente, 2 diferido con intereses, 3 diferido sin intereses
          taxable_amount: this.roundToTwo(this.promotion.taxbaseamount),
          tax_percentage: 15,
          dev_reference: "#" + this.promotion.id,
        }
      }).then((response) => {
        reference = response.data.reference;
      });

      this.alert.show = false;
      this.form.name =
        this.lastname.toUpperCase() + " " + this.name.toUpperCase();
      if(this.termsagreement){
          if(this.continue){
          if(  (this.form.name !== "" &
            this.form.identification !== "" &
            this.form.email !== "" &
            this.form.address !== "" &
            this.form.phone !== "" &
            this.form.city !== "") || (this.completepart & 
            (this.valid.cardname || this.form.name !== "") & 
            (this.valid.street || this.form.address !== "") &
            (this.valid.city || this.form.city !== "")) 
          ){

            this.loading = true;
            this.form.name =
              this.lastname.toUpperCase() + " " + this.name.toUpperCase();
            var paymentCheckout = new PaymentCheckout.modal({
              client_app_code: process.env.VUE_APP_PAYMENTEZ_CODE,
              client_app_key: process.env.VUE_APP_PAYMENTEZ_KEY,
              locale: "es",
              env_mode: process.env.VUE_APP_PAYMENTEZ_ENV,
              onOpen: function () {
                //console.log('modal open');
              },
              onClose: function () {
                this.loading = false;
              },
              onResponse: async function (response) {
                var info = {};
                info.response = response;
                info.cart = window.complete.form;
                info.promotion = window.complete.promotion.id;
                if (response.transaction.status === "success") {
                  await axios
                    .post(process.env.VUE_APP_BACKEND_URL+"/api/completePromotion", info)
                    .then((response) => {
                      window.complete.loading = false;
                      window.complete.complete = true;
                      window.complete.alert.color = "success";
                      window.complete.alert.message =
                        "Muchas gracias por completar su transaccion en breve recibira un correo";
                      window.complete.alert.show = true;
                    })
                    .catch((error) => {
                      window.complete.loading = false;
                      window.complete.alert.color = "danger";
                      window.complete.alert.message =
                        "No se pudo completar la transaccion";
                      window.complete.alert.show = true;
                    });
                } else {
                  await paymentResponseResource
                    .store(
                      {
                        cart: window.complete.form,
                        response: response,
                        items: window.complete.products
                      }
                    )
                    .then((responseRq) => {
                      // console.log(responseRq);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                  window.complete.alert.color = "danger";
                  window.complete.alert.message = response.transaction.message;
                  window.complete.alert.show = true;
                }
              },
            });
            paymentCheckout.open({
              reference: reference
            });
          }else{
            this.alert.color = 'danger';
            this.alert.message = 'Debe completar todos los datos';
            this.alert.show = true;
          }
        }else{
          this.alert.color = 'danger';
          this.alert.message = 'Ingresar una cédula válida';
          this.alert.show = true;
        }
      }else{
        this.alert.color = 'danger';
        this.alert.message = 'Para continuar debes estar de acuerdo con las políticas de privacidad';
        this.alert.show = true;
      }
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    validateEmail(){
      this.validEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
    },
    validateCedula() {
      if (this.form.identityType == "02") {
        const cedula = this.form.identification;
        if (cedula.length == 10) {
          var digito_region = cedula.substring(0, 2);
          if (digito_region >= 1 && digito_region <= 24) {
            var ultimo_digito = cedula.substring(9, 10);
            var pares =
              parseInt(cedula.substring(1, 2)) +
              parseInt(cedula.substring(3, 4)) +
              parseInt(cedula.substring(5, 6)) +
              parseInt(cedula.substring(7, 8));
            var numero1 = cedula.substring(0, 1);
            var numero1 = numero1 * 2;
            if (numero1 > 9) {
              var numero1 = numero1 - 9;
            }
            var numero3 = cedula.substring(2, 3);
            var numero3 = numero3 * 2;
            if (numero3 > 9) {
              var numero3 = numero3 - 9;
            }
            var numero5 = cedula.substring(4, 5);
            var numero5 = numero5 * 2;
            if (numero5 > 9) {
              var numero5 = numero5 - 9;
            }
            var numero7 = cedula.substring(6, 7);
            var numero7 = numero7 * 2;
            if (numero7 > 9) {
              var numero7 = numero7 - 9;
            }
            var numero9 = cedula.substring(8, 9);
            var numero9 = numero9 * 2;
            if (numero9 > 9) {
              var numero9 = numero9 - 9;
            }
            var impares = numero1 + numero3 + numero5 + numero7 + numero9;
            var suma_total = pares + impares;
            var primer_digito_suma = String(suma_total).substring(0, 1);
            var decena = (parseInt(primer_digito_suma) + 1) * 10;
            var digito_validador = decena - suma_total;
            if (digito_validador == 10) var digito_validador = 0;
            if (digito_validador == ultimo_digito) {
              this.validator.identification = true;
              this.validator.identificationValid = "Cédula correcta";
              this.continue = true;
            } else {
              this.validator.identification = false;
              this.validator.identificationInvalid = "Cédula incorrecta";
              this.continue = false;
            }
          } else {
            this.validator.identification = false;
            this.validator.identificationInvalid =
              "Cédula no pertenece a ninguna región";
            this.continue = false;
          }
        } else {
          this.validator.identification = false;
          this.validator.identificationInvalid = "Cédula debe tener 10 dígitos";
          this.continue = false;
        }
      } else {
        this.validator.identification = null;
        this.continue = true;
      }
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },
    onlyNumberId ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if(this.form.identityType !== "03"){
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
        }
      }
    },
  },
  name: "Login",
};
</script>
